<div class="container">
    <p-scrollPanel [style]="{ height: '200px'}">
        <div *ngFor="let record of records">
            <div class="row p-2">
                <div class="col-md-12"  [style]="{'padding-right': '5px', 'padding-left': '5px'}">
                    <p-card class="notification" >
                        <!-- <p-scrollPanel [style]="{ height: '75px'}" styleClass="custombar1"> -->
                            <p>
                                <strong>{{record.notification_name}}</strong>
                            </p>
                            <p>
                                {{record.description}}
                            </p>
                            <div class="d-flex justify-content-between">
                                <p></p>
                                <p>Created At: <strong>
                                    {{ record.createdAt | date:'MM-dd-yyyy'}}
                                </strong></p>
                            </div>
                        <!-- </p-scrollPanel> -->
                    </p-card>
                </div>
                <div class="col-md-4"></div>
            </div>
        </div>
    </p-scrollPanel>
</div>